export const PREFERRED_DESTINATION_LIST_REQUEST = "PREFERRED_DESTINATION_LIST_REQUEST"
export const PREFERRED_DESTINATION_LIST_SUCCESS = "PREFERRED_DESTINATION_LIST_SUCCESS"
export const PREFERRED_DESTINATION_LIST_FAIL = "PREFERRED_DESTINATION_LIST_FAIL"

